import 'bootstrap/dist/css/bootstrap.min.css';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Card } from 'primereact/card';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
// import { Field, Form } from "react-final-form";
import Cookies from 'universal-cookie/es6';
import apis from '../../api';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import '../../utils/react-dates-override.css';
import { Div, FormGroup, Forms, Form, Label } from './CreateEmployee.styles';
import InfoIcon from '../InfoIcon/InfoIcon';
import useInfo from '../hooks/useInfo';
import "../../utils/tooltip.css"
import { Tooltip } from 'primereact/tooltip';
import S3 from "react-aws-s3";
import uploadFileS3 from '../../services/uploadFileS3';
import { Link } from 'react-router-dom';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import { useHistory } from "react-router-dom";
import './CreateEmployee.css'

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CreateEmployee
Description : Creación del contrato de un empleado
Date Autor Modification
================================================================================
22/10/2021 Santiago Coca Rojas Creación – Se implementan la tabla y el formulario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente de acuerdo a los cambios realizados con PrimeReact
================================================================================ */

export default function CreateEmployee(props) {

    /*Propiedades del componente*/
    const [idContrato, setIdContrato] = useState("");
    const [tipoNomina, setTipoNomina] = useState("");
    const [tipoContrato, setTipoContrato] = useState("");
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [fechaInicioSalario, setFechaInicioSalario] = useState("");
    const [estado, setEstado] = useState("");
    const [salario, setSalario] = useState("");
    const [cargo, setCargo] = useState("");
    const [formaPago, setFormaPago] = useState("");
    const [vacaciones, setVacaciones] = useState("");
    const [vacDisfrutadas, setVacDisfrutadas] = useState("");
    const [centroCostos, setCentroCostos] = useState("");
    const [lugarTrabajo, setLugarTrabajo] = useState("");
    const [banco, setBanco] = useState({
        detail_id: "",
        description: "",
        code: ""
    });
    const [tipoCuenta, setTipoCuenta] = useState("");
    const [cuenta, setCuenta] = useState("");
    const [porcentajeRetencion, setPorcentajeRetencion] = useState("");
    const [valorAnoVivienda, setValorAnoVivienda] = useState("");
    const [valorMesVivienda, setValorMesVivienda] = useState("");
    const [fechaInicioVivienda, setFechaInicioVivienda] = useState("");
    const [fechaFinVivienda, setFechaFinVivienda] = useState("");
    const [valorAnoPrepagada, setValorAnoPrepagada] = useState("");
    const [valorMesPrepagada, setValorMesPrepagada] = useState("");
    const [fechaInicioPrepagada, setFechaInicioPrepagada] = useState("");
    const [fechaFinPrepagada, setFechaFinPrepagada] = useState("");
    const [dependiente, setDependiente] = useState("");
    const [fechaInicioDependiente, setFechaInicioDependiente] = useState("");
    const [fechaFinDependiente, setFechaFinDependiente] = useState("");
    const [eps, setEps] = useState("");
    const [afp, setAfp] = useState("");
    const [fces, setFces] = useState("");
    const [ccf, setCcf] = useState("");
    const [afc, setAfc] = useState("");
    const [fvol, setFvol] = useState("");
    const [cuentaAfc, setCuentaAfc] = useState("");
    const [cliente, setCliente] = useState("");
    const [procedimientoRetencion, setProcedimientoRetencion] = useState("");
    const [tipoCotizante, setTipoCotizante] = useState("");
    const [subtipoCotizante, setSubtipoCotizante] = useState("");
    const [arl, setArl] = useState("");
    const [documento, setDocumento] = useState(localStorage.getItem('number_id') ? localStorage.getItem('number_id') : "");
    const [nombre, setNombre] = useState(localStorage.getItem('name') ? localStorage.getItem('name') : "")
    const [retiro, setRetiro] = useState("");
    const [fechaRetiro, setFechaRetiro] = useState("");
    const [actividadEconomica, setActividadEconomica] = useState("");
    const [excluido, setExcluido] = useState("")
    const [files, setFiles] = useState([])
    const [tipoMes, setTipoMes] = useState("")
    const [jornada, setJornada] = useState("")

    /*Listas de valor del componente*/
    const [listaTipoNomina, setListaTipoNomina] = useState([])
    const [listaTipoContrato, setListaTipoContrato] = useState([])
    const [listaEstado, setListaEstado] = useState([])
    const [listaFormasPago, setListaFormasPago] = useState([])
    const [listaVacaciones, setListaVacaciones] = useState([])
    const [listaCargos, setListaCargos] = useState([])
    const [listaCentroCostos, setListaCentroCostos] = useState([])
    const [listaLugarTrabajo, setListaLugarTrabajo] = useState([])
    const [listaBancos, setListaBancos] = useState([])
    const [listaTipoCuenta, setListaTipoCuenta] = useState([])
    const [listaEps, setListaEps] = useState([])
    const [listaAfp, setListaAfp] = useState([])
    const [listaFces, setListaFces] = useState([])
    const [listaCcf, setListaCcf] = useState([])
    const [listaAfc, setListaAfc] = useState([])
    const [listaFvol, setListaFvol] = useState([])
    const [listaArl, setListaArl] = useState([])
    const [listaProcedimientoRetencion, setListaProcedimientoRetencion] = useState([]);
    const [listaTipoCotizante, setListaTipoCotizante] = useState([])
    const [listaSubtipoCotizante, setListaSubtipoCotizante] = useState([])
    const [listaRetiro, setListaRetiro] = useState([])
    const [listaActividadEconomica, setListaActividadEconomica] = useState([])
    const [listaExcluido, setListaExcluido] = useState([])
    const [didMount, setDidMount] = useState(false);
    const [listaTipoMes, setListaTipoMes] = useState([])
    const [listaJornada, setListaJornada] = useState([])

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loadPage, setLoadPage] = useState(false)

    const fileUploadRef = useRef(null);

    /*Mensajes informativos*/
    const { info } = useInfo("CreateEmployee");

    /*Constantes globales para el componente*/
    const headers = {
        authorization: localStorage.getItem('token')
    }

    const [codCargo, setCodCargo] = useState("");
    const [areaCargo, setAreaCargo] = useState("");
    const [nombreCargo, setNombreCargo] = useState("");
    const [isOpenJob, setIsOpenJob] = React.useState(false);
    const [isOpenSalary, setIsOpenSalary] = React.useState(false);
    const [isOpenRetiro, setIsOpenRetiro] = React.useState(false);
    const [disabled1, setDisabled1] = useState(false);
    //const [disabled2, setDisabled2] = useState(false);

    const { width } = useWindowDimensions()

    const [creado, setCreado] = useState(false);

    let history = useHistory();

    const showModalJob = () => {
        setIsOpenJob(true);
    };

    const hideModalJob = () => {
        setIsOpenJob(false);
    };

    const showModalSalary = () => {
        setIsOpenSalary(true);
    };

    const hideModalSalary = () => {
        if (salario && fechaInicioSalario) {
            setIsOpenSalary(false);
        }
        else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Recuerda que debes diligenciar ambos campos asociados al salario", sticky: true });
        }
    };

    const showModalRetiro = () => {
        setIsOpenRetiro(true);
    };

    const hideModalRetiro = () => {
        setIsOpenRetiro(false);
    };

    const elementWidth = { width: "20rem" }
    const labelStyle = { width: "30rem", fontSize: "14px" }
    const labelStyle2 = { width: "24rem", fontSize: "16px", marginTop: "0.5rem" }
    // const cardStyle = {
    //     width: width < 960 ? "100%" : "60vw",
    //     // display: 'flex',
    //     marginBottom: "1rem",
    //     justifyContent: "center",
    //     alignItems: 'center'
    // }
    const cardStyle = {
        width: "100%", marginBottom: "1rem", justifyContent: "center", paddingLeft: '3rem', paddingRight: '3rem',
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }
    const toast = useRef(null);

    /*Formato para el calendar del componente*/
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        setDisabled1(true);
    }, [disabled1])

    useEffect(() => {
        /*Se cargan los datos de la listas de valores del componente*/
        const getLists = async () => {
            await apis.getValueListContract(headers).then(res => {
                let data = res.data
                let tipoNom = data["LOV_SALARY_TYPE"]
                let tipoCon = data["LOV_CONTRACT_TYPE"]
                let status = data["LOV_STATUS"]
                let job = data["JOBS"]
                let sistVac = data["SISTEMA_VACACIONES"]
                let bancos = data["LOV_CODE_BANK"]
                let tipoAcc = data["TIPO_CUENTA"]
                let eps_ = data["EPS"]
                let fces_ = data["FCES"]
                let afp_ = data["AFP"]
                let ccf_ = data["CCF"]
                let afc_ = data["AFC"]
                let fvol_ = data["FVOL"]
                let cenCos = data["CENTRO_COSTO"]
                let arl_ = data["NIVEL_RIESGO_ARL"]
                let procRet = data["PROCEDIMIENTO_RETENCION"]
                let tipoCot = data["TIPO_COTIZANTE"]
                let subtipoCot = data["SUBTIPO_COTIZANTE"]
                let lugarTrabajo = data["WORK_PLACE"]
                let retiro = data["ID_LOV_REASON"]
                let actividad = data["ECONOMIC_ACTIVITY"]
                let excluidos = data["AUX_TRANS_EXCLUDE"]
                let tipoMes = data["TIPO_MES"] ? data["TIPO_MES"] : []
                let jornada = data["JORNADA_LABORAL"] ? data["JORNADA_LABORAL"] : []
                let contenidoTipoNom = []
                let contenidoTipoCon = []
                let contenidoStatus = []
                let contenidoSistVac = []
                let contenidoBancos = []
                let contenidoTipoAcc = []
                let contenidoEps_ = []
                let contenidoFces_ = []
                let contenidoAfp_ = []
                let contenidoCcf_ = []
                let contenidoAfc_ = []
                let contenidoFvol_ = []
                let contenidoCenCos = []
                let contenidoArl_ = []
                let contenidoProcRet = []
                let contenidoTipoCot = []
                let contenidoSubtipoCot = []
                let contenidoCargos = []
                let contenidoLugarTrabajo = []
                let contenidoRetiro = []
                let contenidoActividad = []
                let contenidoTipoMes = []
                let contenidoJornada = []

                tipoNom.forEach(element =>
                    contenidoTipoNom.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                tipoCon.forEach(element =>
                    contenidoTipoCon.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                status.forEach(element =>
                    contenidoStatus.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                sistVac.forEach(element =>
                    contenidoSistVac.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                // bancos.forEach(element =>
                //     contenidoBancos.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                // )
                tipoAcc.forEach(element =>
                    contenidoTipoAcc.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                eps_.forEach(element =>
                    contenidoEps_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                fces_.forEach(element =>
                    contenidoFces_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                afp_.forEach(element =>
                    contenidoAfp_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                ccf_.forEach(element =>
                    contenidoCcf_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                afc_.forEach(element =>
                    contenidoAfc_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                fvol_.forEach(element =>
                    contenidoFvol_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                cenCos.forEach(element =>
                    contenidoCenCos.push({ "value": '' + element.CENTER_ID + '', "label": '' + element.CENTER_NAME + '' })
                )
                arl_.forEach(element =>
                    contenidoArl_.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                procRet.forEach(element =>
                    contenidoProcRet.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                tipoCot.forEach(element =>
                    contenidoTipoCot.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                subtipoCot.forEach(element =>
                    contenidoSubtipoCot.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                job.forEach(element =>
                    contenidoCargos.push({ "value": '' + element.JOB_ID + '', "label": '' + element.NAME + '' })
                )
                lugarTrabajo.forEach(element =>
                    contenidoLugarTrabajo.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                )
                retiro.forEach(element => {
                    contenidoRetiro.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                })
                actividad.forEach(element => {
                    contenidoActividad.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                })
                tipoMes.forEach(element => {
                    contenidoTipoMes.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                })
                jornada.forEach(element => {
                    contenidoJornada.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' })
                })
                setListaTipoNomina(contenidoTipoNom)
                setListaTipoContrato(contenidoTipoCon)
                setListaEstado(contenidoStatus)
                setListaVacaciones(contenidoSistVac)
                setListaCentroCostos(contenidoCenCos)
                setListaBancos(bancos)
                setListaTipoCuenta(contenidoTipoAcc)
                setListaEps(contenidoEps_)
                setListaAfp(contenidoAfp_)
                setListaFces(contenidoFces_)
                setListaCcf(contenidoCcf_)
                setListaAfc(contenidoAfc_)
                setListaFvol(contenidoFvol_)
                setListaArl(contenidoArl_)
                setListaProcedimientoRetencion(contenidoProcRet)
                setListaTipoCotizante(contenidoTipoCot)
                setListaSubtipoCotizante(contenidoSubtipoCot)
                setListaCargos(contenidoCargos)
                setListaLugarTrabajo(contenidoLugarTrabajo)
                setListaRetiro(contenidoRetiro)
                setListaActividadEconomica(contenidoActividad)
                setListaExcluido(excluidos)
                setListaTipoMes(contenidoTipoMes)
                setListaJornada(contenidoJornada)
            })

            /*Se carga la informacion del contrtato, en caso de que exista*/
            if (localStorage.getItem("contract_id")) {
                await apis.getContract(localStorage.getItem('entity'), localStorage.getItem("client"), localStorage.getItem("contract_id"), headers).then(res => {
                    if (res.data["CONTRACT"] != []) {
                        let defaultData = res.data["CONTRACT"][0]
                        let defaultContractId = defaultData["CONTRACT_ID"]
                        let defaultNumberId = defaultData["NUMBER_ID"]
                        let defaultStartDate = defaultData["START_DATE"]
                        let defaultEndDate = defaultData["END_DATE"]
                        let defaultStartDateSalary = defaultData["SALARY"]["START_DATE"]
                        let defaultContractType = defaultData["CONTRACT_TYPE"].split("|")
                        let defaultState = defaultData["STATE"].split("|")
                        let defaultPayrollType = defaultData["PAYROLL_TYPE"].split("|")
                        let defaultVacactionSystem = defaultData["VACATION_SYSTEM"].split("|")
                        let defaultEnjoyedVac = defaultData["TOTAL_VAC"]
                        let defaultWorkPlace = defaultData["WORK_PLACE"].split("|")
                        let defaultSalary = defaultData["SALARY"]["AMOUNT"]
                        let defaultJob = defaultData["JOB_ID"].split("|")
                        let defaultBank = defaultData["BANK"].split("|")
                        let defaultAccountType = defaultData["ACCOUNT_TYPE"] ? defaultData["ACCOUNT_TYPE"].split("|") : ["", ""]
                        let defaultAccountNumber = defaultData["ACCOUNT_NUMBER"]
                        let defaultEps = defaultData["EPS"].split("|")
                        let defaultAfp = defaultData["AFP"].split("|")
                        let defaultFces = defaultData["FCES"].split("|")
                        let defaultCcf = defaultData["CCF"].split("|")
                        let defaultFvol = defaultData["FVOL"].split("|")
                        let defaultAfc = defaultData["AFC"].split("|")
                        let defaultAfcAccount = defaultData["AFC_ACCOUNT"]
                        let defaultRiskLevel = defaultData["RISK_LEVEL"].split("|")
                        let defaultProcRect = defaultData["RETENCION"]["PROC_RET"].split("|")
                        let defaultPorcRect = defaultData["RETENCION"]["PORC_RET"]
                        let defaultValYearVivienda = defaultData["RETENCION"]["DED_VIV"]["VAL_YEAR"]
                        let defaultValMonthVivienda = defaultData["RETENCION"]["DED_VIV"]["VAL_MONTH"]
                        let defaultStartDateVivienda = defaultData["RETENCION"]["DED_VIV"]["START_DATE"]
                        let defaultEndDateVivienda = defaultData["RETENCION"]["DED_VIV"]["END_DATE"]
                        let defaultValYearPrepagada = defaultData["RETENCION"]["DED_MED"]["VAL_YEAR"]
                        let defaultValMonthPrepagada = defaultData["RETENCION"]["DED_MED"]["VAL_MONTH"]
                        let defaultStartDatePrepagada = defaultData["RETENCION"]["DED_MED"]["START_DATE"]
                        let defaultEndDatePrepagada = defaultData["RETENCION"]["DED_MED"]["END_DATE"]
                        let defaultValYearDependiente = defaultData["RETENCION"]["DED_DEP"]["VAL_YEAR"]
                        let defaultValMonthDependiente = defaultData["RETENCION"]["DED_DEP"]["VAL_MONTH"]
                        let defaultStartDateDependiente = defaultData["RETENCION"]["DED_DEP"]["START_DATE"]
                        let defaultEndDateDependiente = defaultData["RETENCION"]["DED_DEP"]["END_DATE"]
                        let defaultTipoCotizante = defaultData["TIPO_COTIZANTE"].split("|")
                        let defaultSubtipoCotizante = defaultData["SUBTIPO_COTIZANTE"].split("|")
                        let defaultCentroCosto = defaultData["CENTRO_COSTO"].split("|")
                        let defaultRetiro = defaultData["CAUSE_RETIREMENT"].split("|")
                        let defaultFechaRetiro = defaultData["RETIREMENT_DATE"]
                        let defaultActividad = defaultData["ECONOMIC_ACTIVITY"].split("|")
                        let defaultExcluido = defaultData["AUX_TRANS_EXCLUDE"].split("|")
                        let defaultTipoMes = defaultData["TIPO_MES"] ? defaultData["TIPO_MES"].split("|") : ["", ""]
                        let defaultJornada = defaultData["LOV_WORKDAY"] ? defaultData["LOV_WORKDAY"].split("|") : ["", ""]
                        let defaultBankCode = defaultData["BANK_CODE"] ? defaultData["BANK_CODE"].split("|") : ["", ""]
                        console.log(nombre)
                        setIdContrato(defaultContractId)
                        setDocumento(defaultNumberId)
                        setFechaInicio(invDateFormat(defaultStartDate))
                        setFechaFin(invDateFormat(defaultEndDate))
                        setFechaInicioSalario(invDateFormat(defaultStartDateSalary))
                        setTipoContrato({ 'value': '' + defaultContractType[0] + '', 'label': '' + defaultContractType[1] + '' })
                        setEstado({ 'value': '' + defaultState[0] + '', 'label': '' + defaultState[1] + '' })
                        setTipoNomina({ 'value': '' + defaultPayrollType[0] + '', 'label': '' + defaultPayrollType[1] + '' })
                        setCargo({ 'value': '' + defaultJob[0] + '', 'label': '' + defaultJob[1] + '' })
                        setVacaciones({ 'value': '' + defaultVacactionSystem[0], 'label': '' + defaultVacactionSystem[1] + '' })
                        setVacDisfrutadas(defaultEnjoyedVac)
                        setLugarTrabajo({ 'value': '' + defaultWorkPlace[0] + '', 'label': '' + defaultWorkPlace[1] + '' })
                        setSalario(defaultSalary)
                        setBanco({ 'detail_id': defaultBank[0], 'description': defaultBank[1], code: defaultBankCode[0] })
                        setTipoCuenta({ 'value': '' + defaultAccountType[0] + '', 'label': '' + defaultAccountType[1] + '' })
                        setCuenta(defaultAccountNumber)
                        setEps({ 'value': '' + defaultEps[0] + '', 'label': '' + defaultEps[1] + '' })
                        setAfp({ 'value': '' + defaultAfp[0] + '', 'label': '' + defaultAfp[1] + '' })
                        setFces({ 'value': '' + defaultFces[0] + '', 'label': '' + defaultFces[1] + '' })
                        setCcf({ 'value': '' + defaultCcf[0] + '', 'label': '' + defaultCcf[1] + '' })
                        setArl({ 'value': '' + defaultRiskLevel[0] + '', 'label': '' + defaultRiskLevel[1] + '' })
                        // setAfc({ 'value': '' + defaultAfc[0] + '', 'label': '' + defaultAfc[1] + '' })
                        // setCentroCostos({ 'value': '' + defaultCentroCosto[0] + '', 'label': '' + defaultCentroCosto[1] + '' })
                        setCuentaAfc(defaultAfcAccount)
                        setProcedimientoRetencion({ 'value': '' + defaultProcRect[0] + '', 'label': '' + defaultProcRect[1] + '' })
                        setPorcentajeRetencion(defaultPorcRect)
                        setValorAnoVivienda(defaultValYearVivienda)
                        setValorMesVivienda(defaultValMonthVivienda)
                        setFechaInicioVivienda(invDateFormat(defaultStartDateVivienda))
                        setFechaFinVivienda(invDateFormat(defaultEndDateVivienda))
                        setValorAnoPrepagada(defaultValYearPrepagada)
                        setValorMesPrepagada(defaultValMonthPrepagada)
                        setFechaInicioPrepagada(invDateFormat(defaultStartDatePrepagada))
                        setFechaFinPrepagada(invDateFormat(defaultEndDatePrepagada))
                        setDependiente(defaultValMonthDependiente)
                        setFechaInicioDependiente(invDateFormat(defaultStartDateDependiente))
                        setFechaFinDependiente(invDateFormat(defaultEndDateDependiente))
                        setTipoCotizante({ 'value': '' + defaultTipoCotizante[0] + '', 'label': '' + defaultTipoCotizante[1] + '' })
                        setSubtipoCotizante({ 'value': '' + defaultSubtipoCotizante[0] + '', 'label': '' + defaultSubtipoCotizante[1] + '' })
                        if (defaultRetiro[0] !== '') {
                            setRetiro({ 'value': '' + defaultRetiro[0] + '', 'label': '' + defaultRetiro[1] + '' })
                            setFechaRetiro(invDateFormat(defaultFechaRetiro))
                        }
                        if (defaultAfc[0] != '') {
                            setAfc({ 'value': '' + defaultAfc[0] + '', 'label': '' + defaultAfc[1] + '' })
                        }
                        if (defaultFvol[0] != '') {
                            setFvol({ 'value': '' + defaultFvol[0] + '', 'label': '' + defaultFvol[1] + '' })
                        }
                        if (defaultCentroCosto[0] != '') {
                            setCentroCostos({ 'value': '' + defaultCentroCosto[0] + '', 'label': '' + defaultCentroCosto[1] + '' })
                        }
                        setActividadEconomica({ 'value': '' + defaultActividad[0] + '', 'label': '' + defaultActividad[1] + '' })
                        setExcluido({ detail_id: defaultExcluido[0], description: defaultExcluido[1] })
                        setTipoMes({ value: defaultTipoMes[0], label: defaultTipoMes[1] })
                        setJornada({ value: defaultJornada[0], label: defaultJornada[1] })
                    }
                })
            }
            setLoadPage(true)
            if (!(localStorage.getItem("number_id")) && !creado) {
                toast.current.show({
                    severity: 'warn', sticky: true, content: (
                        <div className="flex flex-column" style={{ flex: '1' }}>
                            <div className="text-center">
                                <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                                <p>Inconviente al cargar la cédula del contrato. Por favor regrese a la pantalla anterior e inténtelo de nuevo.</p>
                            </div>
                            <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                                <Link style={{ textDecoration: 'none' }} to="/CreatePerson">
                                    <Button type="button" label="Regresar" className="p-button-success" />
                                </Link>
                            </div>
                        </div>
                    )
                });
            }
            setCliente(localStorage.getItem("client"))
            setDidMount(true);
            return () => setDidMount(false);
        }
        getLists()
    }, [])

    const handleClick = (event) => {
        /*Maneja el estado de la checkbox del formulario del componente*/
        if (event === true) {
            setDependiente("1");
        }
        else {
            setDependiente("");
        }
    }

    const handleClickExcluido = (event) => {
        /*Maneja el estado de la checkbox del formulario del componente*/
        let exc = ""
        if (event === true) {
            exc = listaExcluido.find(ex => ex.description === "SI")
            setExcluido(exc);
        }
        else {
            setExcluido("");
        }
    }

    function getMissingRequiredFields() {
        const missing = [];

        if (!tipoNomina || !tipoNomina.value) missing.push("Tipo salario");
        if (!tipoContrato || !tipoContrato.value) missing.push("Tipo de contrato");
        if (!fechaInicio) missing.push("Fecha inicio contrato");
        if (tipoContrato && tipoContrato.value !== "358" && !fechaFin) missing.push("Fecha fin contrato");
        if (!estado || !estado.value) missing.push("Estado");
        if (!salario) missing.push("Salario");
        if (!cargo || !cargo.value) missing.push("Cargo");
        if (!vacaciones || !vacaciones.value) missing.push("Sistema de vacaciones");
        if (!vacDisfrutadas) missing.push("Vacaciones disfrutadas");
        if (!lugarTrabajo || !lugarTrabajo.value) missing.push("Lugar de trabajo");
        if (!banco || !banco.detail_id) missing.push("Banco");
        if (banco && banco.code !== '00' && (!tipoCuenta || !tipoCuenta.value)) missing.push("Tipo de cuenta");
        if (banco && banco.code !== '00' && !cuenta) missing.push("Número de cuenta");
        if (!procedimientoRetencion || !procedimientoRetencion.value) missing.push("Procedimiento retención");
        if (!porcentajeRetencion) missing.push("Porcentaje retención");
        if (!eps || !eps.value) missing.push("EPS");
        if (!afp || !afp.value) missing.push("AFP");
        if (!fces || !fces.value) missing.push("Fondo cesantías");
        if (!ccf || !ccf.value) missing.push("Caja compensación");
        if (!arl || !arl.value) missing.push("Nivel de riesgo ARL");
        if (!tipoCotizante || !tipoCotizante.value) missing.push("Tipo cotizante");
        if (!subtipoCotizante || !subtipoCotizante.value) missing.push("Subtipo cotizante");
        if (!actividadEconomica || !actividadEconomica.value) missing.push("Actividad económica");
        if (!jornada || !jornada.value) missing.push("Jornada laboral");
        if ((afc && afc.value) && !cuentaAfc) missing.push('Cuenta AFC')

        // Conditional required fields
        if (valorAnoVivienda) {
            if (!valorMesVivienda) missing.push("Valor mes certificado vivienda");
            if (!fechaInicioVivienda) missing.push("Inicio certificado vivienda");
            if (!fechaFinVivienda) missing.push("Fin certificado vivienda");
        }
        if (valorAnoPrepagada) {
            if (!valorMesPrepagada) missing.push("Valor mes certificado medicina prepagada");
            if (!fechaInicioPrepagada) missing.push("Inicio certificado medicina prepagada");
            if (!fechaFinPrepagada) missing.push("Fin certificado medicina prepagada");
        }
        if (dependiente === "1") {
            if (!fechaInicioDependiente) missing.push("Inicio certificado dependiente");
            if (!fechaFinDependiente) missing.push("Fin certificado dependiente");
        }

        return missing;
    }

    const handleGuardar = async () => {
        const missingFields = getMissingRequiredFields();
        if (missingFields.length > 0) {
            toast.current.show({
                severity: 'warn',
                summary: 'Campos requeridos',
                detail: `Por favor completa los siguientes campos marcados con * : ${missingFields.join(', ')}`,
                sticky: true
            });
            setLoading1(false);
            return;
        }
        setLoading1(true);
        await processes();
    };

    function onSubmit(event) {
        console.log(event)
    }

    const showConfirm = (id, _numberId, process) => {
        /*Función encargada de mostrar al usuaro un mensaje de confirmación de la realización de un proceso*/
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem' }}></i>
                        <p>Contrato para {_numberId}({id}) {process} existosamente</p>
                    </div>
                    <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <Link style={{ textDecoration: 'none' }} to="/Employes">
                            <Button type="button" label="Continuar" className="p-button-success" onClick={() => localStorage.removeItem('image')} />
                        </Link>
                    </div>
                </div>
            )
        });
    }

    async function postContractInfo() {
        /*Función encargada de crear un nuevo contrato*/
        localStorage.removeItem('contract_id')
        let _tipoNomina = tipoNomina.value;
        let _tipoContrato = tipoContrato.value;
        let _fechaInicio = dateFormat(fechaInicio);
        let _fechaFin = dateFormat(fechaFin);
        let _fechaInicioSalario = dateFormat(fechaInicioSalario);
        let _estado = estado.value;
        let _salario = { AMOUNT: salario, START_DATE: _fechaInicioSalario, END_DATE: "" };
        let _cargo = cargo.value;
        let _formaPago = formaPago.value;
        let _vacaciones = vacaciones.value;
        let _vacDisfrutadas = vacDisfrutadas;
        let _centroCostos = centroCostos.value;
        let _lugarTrabajo = lugarTrabajo.value;
        let _banco = banco.detail_id;
        let _tipoCuenta = tipoCuenta.value;
        let _cuenta = cuenta;
        let _eps = eps.value;
        let _afp = afp.value;
        let _fces = fces.value;
        let _ccf = ccf.value;
        let _afc = afc.value;
        let _fvol = fvol.value;
        let _client = cliente;
        let _entity = localStorage.getItem('entity')
        let _cuentaAfc = cuentaAfc;
        let _arl = arl.value;
        let _retencion = {
            PROC_RET: procedimientoRetencion.value,
            PORC_RET: porcentajeRetencion,
            DED_VIV: {
                VAL_YEAR: valorAnoVivienda,
                VAL_MONTH: valorMesVivienda,
                START_DATE: dateFormat(fechaInicioVivienda),
                END_DATE: dateFormat(fechaFinVivienda)
            },
            DED_MED: {
                VAL_YEAR: valorAnoPrepagada,
                VAL_MONTH: valorMesPrepagada,
                START_DATE: dateFormat(fechaInicioPrepagada),
                END_DATE: dateFormat(fechaFinPrepagada)
            },
            DED_DEP: {
                VAL_YEAR: dependiente,
                VAL_MONTH: dependiente,
                START_DATE: dateFormat(fechaInicioDependiente),
                END_DATE: dateFormat(fechaFinDependiente)
            }
        };
        let _tipoCotizante = tipoCotizante.value;
        let _subtipoCotizante = subtipoCotizante.value;
        // let _numberId = localStorage.getItem('number_id');
        let _numberId = documento;

        if (cargo == "--" || cargo == undefined || cargo == null) {
            _cargo = "";
        }
        if (formaPago == "--" || formaPago == undefined || formaPago == null) {
            _formaPago = "";
        }
        if (centroCostos == "--" || centroCostos == undefined || centroCostos == null) {
            _centroCostos = "";
        }
        if (lugarTrabajo == "--" || lugarTrabajo == undefined || lugarTrabajo == null) {
            _lugarTrabajo = "";
        }
        if (afc.value == "--" || afc.value == undefined || afc.value == null) {
            _afc = "";
        }
        if (fvol.value == "--" || fvol.value == undefined || fvol.value == null) {
            _fvol = "";
        }
        if (cuentaAfc == "--" || cuentaAfc == undefined || cuentaAfc == null) {
            _cuentaAfc = "";
        }
        if (arl.value == "--" || arl.value == undefined || arl.value == null) {
            _arl = "";
        }

        let _retiro = retiro.value;
        let _fechaRetiro = dateFormat(fechaRetiro);
        let _actividad = actividadEconomica.value
        let _excluido = excluido ? excluido.detail_id : ""
        let _tipoMes = tipoMes ? tipoMes.value : ""
        let _jornada = jornada ? jornada.value : ""

        const employee = {
            PAYROLL_TYPE: _tipoNomina,
            CONTRACT_TYPE: _tipoContrato,
            START_DATE: _fechaInicio,
            END_DATE: _fechaFin,
            STATE: _estado,
            SALARY: _salario,
            JOB_ID: _cargo,
            PAY_METHOD: _formaPago,
            VACATION_SYSTEM: _vacaciones,
            TOTAL_VAC: _vacDisfrutadas,
            CENTRO_COSTO: _centroCostos,
            WORK_PLACE: _lugarTrabajo,
            BANK: _banco,
            ACCOUNT_TYPE: _tipoCuenta,
            ACCOUNT_NUMBER: _cuenta,
            EPS: _eps,
            AFP: _afp,
            FCES: _fces,
            CCF: _ccf,
            AFC: _afc,
            FVOL: _fvol,
            NUMBER_ID: _numberId,
            CLIENT: _client,
            ENTITY: _entity,
            AFC_ACCOUNT: _cuentaAfc,
            RISK_LEVEL: _arl,
            RETENCION: _retencion,
            TIPO_COTIZANTE: _tipoCotizante,
            SUBTIPO_COTIZANTE: _subtipoCotizante,
            CAUSE_RETIREMENT: _retiro,
            RETIREMENT_DATE: _fechaRetiro,
            ECONOMIC_ACTIVITY: _actividad,
            AUX_TRANS_EXCLUDE: _excluido,
            TIPO_MES: _tipoMes,
            LOV_WORKDAY: _jornada
        }

        console.log(employee)
        try {
            await apis.postContract(employee, headers).then(res => {
                setLoading1(false)
                showConfirm(res.data.CONTRACT[0]["CONTRACT_ID"], res.data.CONTRACT[0]["NUMBER_ID"], "creado")
                localStorage.removeItem('number_id')
                setCreado(true)
                if (files.length > 0) {
                    try {
                        let _archivo = files[0]
                        let _cliente = localStorage.getItem("client")
                        let _entity = localStorage.getItem('entity')
                        let _contrato = res.data.CONTRACT[0]["CONTRACT_ID"]
                        let url = uploadFileS3(_entity, _cliente, _archivo, "empleados", _contrato, 'jpg', headers)
                        localStorage.setItem('image', url)
                    }
                    catch (err) {
                        setLoading1(false)
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
                    }
                }
            })

            localStorage.removeItem('personId');
        } catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putContractInfo() {
        /*Función encargada de actualizar la información de un contrato*/
        localStorage.removeItem('contract_id')
        let _cliente = cliente
        let _entity = localStorage.getItem('entity')
        let _idContrato = idContrato
        let _tipoNomina = tipoNomina.value;
        let _tipoContrato = tipoContrato.value;
        let _fechaInicio = dateFormat(fechaInicio);
        let _fechaFin = dateFormat(fechaFin);
        let _fechaInicioSalario = dateFormat(fechaInicioSalario);
        let _estado = estado.value;
        let _salario = { AMOUNT: salario, START_DATE: _fechaInicioSalario, END_DATE: "" };
        let _cargo = cargo.value;
        let _formaPago = formaPago.value;
        let _vacaciones = vacaciones.value;
        let _centroCostos = centroCostos.value;
        let _lugarTrabajo = lugarTrabajo.value;
        let _banco = banco.detail_id;
        let _tipoCuenta = tipoCuenta.value;
        let _cuenta = cuenta;
        let _eps = eps.value;
        let _afp = afp.value;
        let _fces = fces.value;
        let _ccf = ccf.value;
        let _afc = afc.value;
        let _fvol = fvol.value;
        let _client = cliente;
        let _cuentaAfc = cuentaAfc;
        let _arl = arl.value;
        let _retencion = {
            PROC_RET: procedimientoRetencion.value,
            PORC_RET: porcentajeRetencion,
            DED_VIV: {
                VAL_YEAR: valorAnoVivienda,
                VAL_MONTH: valorMesVivienda,
                START_DATE: dateFormat(fechaInicioVivienda),
                END_DATE: dateFormat(fechaFinVivienda)
            },
            DED_MED: {
                VAL_YEAR: valorAnoPrepagada,
                VAL_MONTH: valorMesPrepagada,
                START_DATE: dateFormat(fechaInicioPrepagada),
                END_DATE: dateFormat(fechaFinPrepagada)
            },
            DED_DEP: {
                VAL_YEAR: dependiente,
                VAL_MONTH: dependiente,
                START_DATE: dateFormat(fechaInicioDependiente),
                END_DATE: dateFormat(fechaFinDependiente)
            }
        };
        let _tipoCotizante = tipoCotizante.value;
        let _subtipoCotizante = subtipoCotizante.value;
        let _numberId = documento;

        if (afc.value == "--" || afc.value == undefined || afc.value == null) {
            _afc = "";
        }
        if (fvol.value == "--" || fvol.value == undefined || fvol.value == null) {
            _fvol = "";
        }
        if (cuentaAfc == "--" || cuentaAfc == undefined || cuentaAfc == null) {
            _cuentaAfc = "";
        }
        if (arl.value == "--" || arl.value == undefined || arl.value == null) {
            _arl = "";
        }
        if (centroCostos.value == "--" || centroCostos.value == undefined || centroCostos.value == null) {
            _centroCostos = "";
        }

        let _retiro = retiro ? retiro.value : "";
        let _fechaRetiro = fechaRetiro ? dateFormat(fechaRetiro) : "";
        let _actividad = actividadEconomica.value
        let _excluido = excluido ? excluido.detail_id : ""
        let _tipoMes = tipoMes ? tipoMes.value : ""
        let _jornada = jornada ? jornada.value : ""

        const employee = {
            CONTRACT: [{
                CLIENT: _cliente,
                ENTITY: _entity,
                CONTRACT_ID: _idContrato,
                PAYROLL_TYPE: _tipoNomina,
                CONTRACT_TYPE: _tipoContrato,
                START_DATE: _fechaInicio,
                END_DATE: _fechaFin,
                STATE: _estado,
                SALARY: _salario,
                JOB_ID: _cargo,
                PAY_METHOD: _formaPago,
                VACATION_SYSTEM: _vacaciones,
                CENTRO_COSTO: _centroCostos,
                WORK_PLACE: _lugarTrabajo,
                BANK: _banco,
                ACCOUNT_TYPE: _tipoCuenta,
                ACCOUNT_NUMBER: _cuenta,
                EPS: _eps,
                AFP: _afp,
                FCES: _fces,
                CCF: _ccf,
                AFC: _afc,
                FVOL: _fvol,
                NUMBER_ID: _numberId,
                CLIENT: _client,
                AFC_ACCOUNT: _cuentaAfc,
                RISK_LEVEL: _arl,
                RETENCION: _retencion,
                TIPO_COTIZANTE: _tipoCotizante,
                SUBTIPO_COTIZANTE: _subtipoCotizante,
                CAUSE_RETIREMENT: _retiro,
                RETIREMENT_DATE: _fechaRetiro,
                ECONOMIC_ACTIVITY: _actividad,
                AUX_TRANS_EXCLUDE: _excluido,
                TIPO_MES: _tipoMes,
                LOV_WORKDAY: _jornada
            }]
        }

        console.log(employee)
        try {
            await apis.putContract(employee, headers).then(res => {
                setLoading1(false)
                showConfirm(res.data.CONTRACT[0]["CONTRACT_ID"], res.data.CONTRACT[0]["NUMBER_ID"], "actualizado")
                localStorage.removeItem('number_id')
                setCreado(true)
                // console.log(fileUploadRef.current.files[0])
                if (files.length > 0) {
                    try {
                        let _archivo = files[0]
                        let _cliente = localStorage.getItem("client")
                        let _entity = localStorage.getItem('entity')
                        let _contrato = res.data.CONTRACT[0]["CONTRACT_ID"]
                        let url = uploadFileS3(_entity, _cliente, _archivo, "empleados", _contrato, 'jpg', headers)
                        localStorage.setItem('image', url)
                    }
                    catch (err) {
                        setLoading1(false)
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
                    }
                }
            })
            localStorage.removeItem('personId');
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putSalary() {
        const _cliente = localStorage.getItem('client');
        const _entity = localStorage.getItem('entity')
        const _contrato = idContrato;
        const _salario = salario
        const _fechaInicioSalario = dateFormat(fechaInicioSalario);

        const newSalary = {
            CLIENT: _cliente,
            ENTITY: _entity,
            CONTRACT_ID: _contrato,
            AMOUNT: _salario,
            START_DATE: _fechaInicioSalario,
            END_DATE: ""
        }

        try {
            await apis.putContractSalary(newSalary, headers).then(res => {
                setLoading3(false)
                hideModalSalary()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Salario actualizado correctamente" });
            })
        }
        catch (err) {
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function processes() {
        /*Función que valida si el contrato existe, para de esa manera saber que proceso ejecutar*/
        if (idContrato == undefined || idContrato == -1 || idContrato == null || idContrato == "") {
            //console.log("Hola:" + idContrato)
            postContractInfo();
        }
        else {
            putContractInfo();
        }
    }

    async function createJob() {
        /*Función encargada de crear un cargo nuevo y actualizar la lista de cargos*/
        const _codCargo = codCargo
        const _areaCargo = areaCargo
        const _nombreCargo = nombreCargo
        const _cliente = localStorage.getItem('client')
        const _entity = localStorage.getItem('entity')

        const job = {
            CLIENT: _cliente,
            ENTITY: _entity,
            CODE: _codCargo,
            AREA: _areaCargo,
            NAME: _nombreCargo
        }

        try {
            await apis.postJobs(job, headers).then(res => {
                let data = res.data.JOBS[0]
                setCargo({ "value": data.JOB_ID, "label": data.NAME })
                limpiarJob()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cargo agregado exitosamente', life: 4000 });
                setLoading2(false)
                hideModalJob();
            })
            await apis.getJobs(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
                let data = res.data.JOBS
                let contenidoCargos = []
                data.forEach(element => {
                    contenidoCargos.push({ "value": element.JOB_ID, "label": element.NAME })
                })
                setListaCargos(contenidoCargos)
            })
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const addJobFooter = (
        <div>
            <Button onClick={hideModalJob}>Cancelar</Button>
            <Button onClick={() => { setLoading2(); createJob() }} label='Guardar' loading={loading2}></Button>
        </div>
    );

    const addJobHeader = (
        <div>
            <h3>Agregar Cargo</h3>
        </div>
    );

    // const salaryFooter = (
    //     <div>
    //         {localStorage.getItem('contract_id') ?
    //             <Button onClick={() => { setLoading3(true); putSalary() }} label='Guardar' loading={loading3} />
    //             : null}
    //     </div>
    // );

    const salaryHeader = (
        <div>
            <h3>Modificar salario</h3>
        </div>
    );

    const retiroFooter = (
        <div>
            <Button onClick={() => { hideModalRetiro() }} label='Listo' disabled={fechaRetiro === '' && retiro === ''} />
        </div>
    )

    const retiroHeader = (
        <div>
            <h3>Retiro</h3>
        </div>
    );

    async function limpiarJob() {
        setCodCargo("")
        setAreaCargo("")
        setNombreCargo("")
    }

    function handleSubmit(event) {
        event.preventDefault();
    }
    /*Renderizado del componente*/
    return (
        <div className="flex align-items-center justify-content-center card-container">
            <Form onSubmit={handleSubmit}>
                <Tooltip target=".info" className='indigo-tooltip ml-1' />
                <Dialog header={addJobHeader} footer={addJobFooter} visible={isOpenJob} position="top" style={{ width: "28rem" }}
                    draggable={false} resizable={false} modal onHide={hideModalJob}>
                    <Label htmlFor="label">Código cargo</Label>
                    <InputText value={codCargo} onChange={(e) => setCodCargo(e.target.value)} placeholder="Código cargo" />
                    <Label htmlFor="label">Área del cargo</Label>
                    <InputText value={areaCargo} onChange={(e) => setAreaCargo(e.target.value)} placeholder="Área" />
                    <Label htmlFor="label">Nombre del cargo</Label>
                    <InputText value={nombreCargo} onChange={(e) => setNombreCargo(e.target.value)} placeholder="Cargo" />
                </Dialog>
                <Dialog header={salaryHeader} visible={isOpenSalary} position="top" style={{ width: "28rem" }}
                    draggable={false} resizable={false} modal onHide={hideModalSalary}>
                    <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                    <Label htmlFor="label">Salario *</Label>
                    <InputNumber value={salario}
                        onValueChange={(e) => { setSalario(e.value);  }}
                        mode="currency" currency="COP" locale="es-CO"
                        disabled={localStorage.getItem('contract_id')} />
                    <Label htmlFor="label">Fecha inicio *</Label>
                    <Calendar id="navigators" value={fechaInicioSalario}
                        onChange={(e) => { setFechaInicioSalario(e.value);  }}
                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioSalario}
                        yearRange="1900:2060"
                        disabled={localStorage.getItem('contract_id')} />
                </Dialog>
                <Toast ref={toast} />
                <div style={{
                    marginBottom: "2rem",
                    marginTop: "5rem",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'justify'
                }}
                    className="mb-3 font-bold text-4xl flex justify-content-center align-items-center">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        flexDirection: width > 960 ? 'row' : 'column-reverse'
                    }}>
                        <img className='border-1' alt={""} src={localStorage.getItem('image')} width={120} height={120}
                            style={{
                                verticalAlign: 'middle',
                                borderRadius: '60px',
                                marginRight: width > 960 && "8rem"
                            }}
                        />
                        <span className="text-900"
                            style={{
                                marginRight: width > 960 && "16rem"
                            }}
                        >
                            Información laboral
                        </span>
                    </div>
                    <label htmlFor="label"
                        style={{
                            // marginLeft: width > 960 && "20rem",
                            // position: 'fixed',
                            marginTop: "2rem",
                            fontSize: "16px",
                            color: '#3498DB'
                        }}
                    >
                        (*) Campos obligatorios
                    </label>
                </div>
                <SkeletonTable load={loadPage}>
                    <div className='flex justify-content-center'>
                        <Forms>
                            <Tooltip target=".info" className='indigo-tooltip ml-1' />
                            <Card title="Contrato" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Tooltip target=".disabled-button" />
                                        <Label htmlFor="label">{width > 321 ? "Número" : "N°"} documento</Label>
                                        <InfoIcon msg={info[40]}
                                            element={
                                                <InputText
                                                    id="label7"
                                                    type="text"
                                                    className="cont"
                                                    value={documento}
                                                    disabled={true}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Tooltip target=".disabled-button" />
                                        <Label htmlFor="label">Contrato - Nombre</Label>
                                        <InfoIcon msg={info[41]}
                                            element={
                                                <InputText
                                                    id="label7"
                                                    type="text"
                                                    className="cont"
                                                    value={idContrato + '-' + nombre}
                                                    disabled={true}
                                                    tooltip={idContrato + '-' + nombre}
                                                    tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo salario*</Label>
                                        <InfoIcon msg={info[0]}
                                            element={
                                                <Dropdown value={tipoNomina} autoFocus
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoNomina({ "value": e.value, "label": label })
                                                        
                                                    }}
                                                    options={listaTipoNomina} placeholder={tipoNomina.label}
                                                />}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo de contrato*</Label>
                                        <InfoIcon msg={info[1]}
                                            element={
                                                <Dropdown value={tipoContrato}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoContrato({ "value": e.value, "label": label })
                                                        
                                                    }}
                                                    options={listaTipoContrato} placeholder={tipoContrato.label} />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Fecha inicio contrato*</Label>
                                        <InfoIcon msg={info[2]}
                                            element={
                                                <Calendar id="navigators" value={fechaInicio}
                                                    className="cont"
                                                    onChange={(e) => { setFechaInicio(e.value);  }}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicio}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Fecha fin contrato{tipoContrato && tipoContrato.value !== "358" && "*"}</Label>
                                        <InfoIcon msg={info[3]}
                                            element={
                                                <Calendar id="navigators" value={fechaFin}
                                                    className="cont"
                                                    onChange={(e) => { setFechaFin(e.value) }}
                                                    disabled={tipoContrato.value === "358" && true}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFin}
                                                    yearRange="1900:2060"
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Fecha retiro</Label>
                                        <InfoIcon msg={info[2]}
                                            element={
                                                <Calendar id="navigators" value={fechaRetiro}
                                                    className="cont"
                                                    onChange={(e) => { setFechaRetiro(e.value) }}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaRetiro}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Causa retiro</Label>
                                        <InfoIcon msg={info[3]}
                                            element={
                                                <Dropdown value={retiro}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay causas disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setRetiro({ "value": e.value, "label": label })
                                                        // 
                                                        console.log(e.value)
                                                        // if (e.value === "366") {
                                                        //     showModalRetiro()
                                                        // }
                                                    }}
                                                    options={listaRetiro} placeholder={retiro.label} />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Estado*</Label>
                                        <InfoIcon msg={info[4]}
                                            element={
                                                <Dropdown value={estado}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay estados disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setEstado({ "value": e.value, "label": label })
                                                        
                                                        console.log(e.value)
                                                        if (e.value === "366") {
                                                            showModalRetiro()
                                                        }
                                                    }}
                                                    options={listaEstado} placeholder={estado.label} />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Salario*</Label>
                                        <InfoIcon msg={info[5]}
                                            element={
                                                <div className="p-inputgroup cont">
                                                    <InputNumber value={salario}
                                                        style={{ width: '2rem' }}
                                                        onValueChange={(e) => { setSalario(e.value);  }}
                                                        mode="currency" currency="COP" locale="es-CO"
                                                        disabled={true} />
                                                    {localStorage.getItem("type") !== "CLIENT" &&
                                                        <Button icon="pi pi-dollar" className="p-button-success mr-2 p-button-sm text-xs"
                                                            tooltip={width > 426 && "Información del salario"} onClick={() => showModalSalary()} />}
                                                </div>
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Cargo*</Label>
                                        <InfoIcon msg={info[6]}
                                            element={
                                                <div className="p-inputgroup cont">
                                                    <Dropdown value={cargo}
                                                        // className="cont"
                                                        filter showClear filterBy="label" emptyMessage={"No hay cargos disponibles"}
                                                        onChange={(e) => {
                                                            let label = e.originalEvent.nativeEvent.target.textContent;
                                                            setCargo({ "value": e.value, "label": label })
                                                            
                                                        }}
                                                        options={listaCargos} placeholder={cargo.label} />
                                                    {localStorage.getItem('type') === 'ADMIN' &&
                                                        <Button icon="pi pi-plus" className="p-button-success"
                                                            tooltip={width > 426 && "Agregar cargo nuevo"} onClick={() => showModalJob()} />}
                                                </div>
                                            } />
                                    </FormGroup>
                                    {/*<FormGroup>
                                <Label  htmlFor="label">Forma de pago *</Label>
                                <Dropdown  value={formaPago} 
                                    filter showClear filterBy="label"
                                    onChange={(e) => {
                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                        setFormaPago({"value":e.value, "label":label})
                                    }} 
                                    options={listaFormasPago} placeholder={formaPago.label}/>
                                // </FormGroup>*/}
                                    <FormGroup>
                                        <Label htmlFor="label">Sistema de vacaciones*</Label>
                                        <InfoIcon msg={info[7]}
                                            element={
                                                <Dropdown value={vacaciones}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay sistemas disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setVacaciones({ "value": e.value, "label": label })
                                                        
                                                    }}
                                                    options={listaVacaciones} placeholder={vacaciones.label} />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Vacaciones disfrutadas*</Label>
                                        <InfoIcon msg={info[8]}
                                            element={
                                                <InputText
                                                    id="label7"
                                                    type="number"
                                                    className="cont"
                                                    value={vacDisfrutadas}
                                                    disabled={idContrato}
                                                    min={0}
                                                    onChange={(e) => setVacDisfrutadas(e.target.value)}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Centro de costos</Label>
                                        <InfoIcon msg={info[9]}
                                            element={
                                                <Dropdown value={centroCostos}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => {
                                                        console.log(listaCentroCostos)
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setCentroCostos({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaCentroCostos} placeholder={centroCostos.label} />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div
                                // style={{
                                //     width: width > 960 && "75%"
                                // }}
                                >
                                    <FormGroup>
                                        <Label htmlFor="label">Lugar de trabajo*</Label>
                                        <InfoIcon msg={info[10]}
                                            element={
                                                <Dropdown value={lugarTrabajo}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay lugares disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setLugarTrabajo({ "value": e.value, "label": label })
                                                        
                                                    }}
                                                    options={listaLugarTrabajo} placeholder={lugarTrabajo.label} />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Excluido pago subsidio de transporte</Label>
                                        <InfoIcon msg={info[39]}
                                            element={
                                                <div>
                                                    <Checkbox
                                                        inputId="binary"
                                                        checked={excluido && excluido.description === "SI"}
                                                        onChange={(e) => { handleClickExcluido(e.checked); console.log(excluido) }}
                                                    />
                                                    <label htmlFor="binary" className='ml-1'>{excluido && excluido.description === "SI" ? "Si" : "No"}</label>
                                                </div>
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Días del mes para salario</Label>
                                        <InfoIcon msg={info[42]}
                                            element={
                                                <Dropdown value={tipoMes}
                                                    className="cont"
                                                    tooltip={tipoMes.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                    filter showClear filterBy="label" emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoMes({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaTipoMes} placeholder={tipoMes.label} />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Jornada laboral*</Label>
                                        <InfoIcon msg={info[43]}
                                            element={
                                                <Dropdown value={jornada}
                                                    className="cont"
                                                    tooltip={jornada.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                    filter showClear filterBy="label" emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setJornada({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaJornada} placeholder={jornada.label} />
                                            } />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <Card title="Datos bancarios" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Banco*</Label>
                                        <InfoIcon msg={info[11]}
                                            element={
                                                <Dropdown value={banco}
                                                    className="cont" optionLabel='description'
                                                    filter showClear filterBy="description" emptyMessage={"No hay bancos disponibles"}
                                                    onChange={(e) => {
                                                        if (e.target.value !== undefined) {
                                                            setBanco(e.target.value)
                                                        }
                                                        else {
                                                            setBanco({
                                                                detail_id: "",
                                                                description: "",
                                                                code: ""
                                                            })
                                                        }
                                                        
                                                    }}
                                                    options={listaBancos} placeholder={banco ? banco.description : ""} />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo de cuenta{banco.code !== '00' && '*'}</Label>
                                        <InfoIcon msg={info[12]}
                                            element={
                                                <Dropdown value={tipoCuenta}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoCuenta({ "value": e.value, "label": label })
                                                        
                                                    }}
                                                    options={listaTipoCuenta} placeholder={tipoCuenta.label} />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div
                                >
                                    <FormGroup>
                                        <Label htmlFor="label">Número de cuenta{banco.code !== '00' && '*'}</Label>
                                        <InfoIcon msg={info[13]}
                                            element={
                                                <InputText
                                                    className="cont"
                                                    id="label6"
                                                    type="text"
                                                    value={cuenta}
                                                    onChange={(e) => { setCuenta(e.target.value);  }}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup style={{ display: width < 961 && 'none' }}>
                                        <Label htmlFor="label" style={{ display: 'none' }}>Número de cuenta*</Label>
                                        <InputText
                                            id="label6"
                                            type="text"
                                            style={{ display: 'none' }}
                                            value={cuenta}
                                            disabled
                                            onChange={(e) => { setCuenta(e.target.value);  }}
                                        />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <Card title="Retención" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Procedimiento retención*</Label>
                                        <InfoIcon msg={info[14]}
                                            element={
                                                <Dropdown value={procedimientoRetencion}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay procedimientos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setProcedimientoRetencion({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaProcedimientoRetencion} placeholder={procedimientoRetencion.label} />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Porcentaje retención*</Label>
                                        <InfoIcon msg={info[15]}
                                            element={
                                                <InputText
                                                    className="cont"
                                                    id="label7"
                                                    type="number"
                                                    value={porcentajeRetencion}
                                                    onChange={(e) => setPorcentajeRetencion(e.target.value)}
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Valor año {width > 375 && "certificado"} vivienda{valorAnoVivienda && "*"}</Label>
                                        <InfoIcon msg={info[16]}
                                            element={
                                                <InputNumber
                                                    className="cont"
                                                    value={valorAnoVivienda}
                                                    onChange={(e) => setValorAnoVivienda(e.value)}
                                                    mode="currency" currency="COP" locale="es-CO"
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Valor mes {width > 375 && "certificado"} vivienda{valorAnoVivienda && "*"}</Label>
                                        <InfoIcon msg={info[17]}
                                            element={
                                                <InputNumber
                                                    className="cont"
                                                    value={valorMesVivienda}
                                                    onChange={(e) => setValorMesVivienda(e.value)}
                                                    mode="currency" currency="COP" locale="es-CO"
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Inicio certificado vivienda{valorAnoVivienda && "*"}</Label>
                                        <InfoIcon msg={info[18]}
                                            element={
                                                <Calendar id="navigators" value={fechaInicioVivienda}
                                                    className="cont"
                                                    onChange={(e) => setFechaInicioVivienda(e.value)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioVivienda}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Fin certificado vivienda {valorAnoVivienda && "*"}</Label>
                                        <InfoIcon msg={info[19]}
                                            element={
                                                <Calendar id="navigators" value={fechaFinVivienda}
                                                    className="cont"
                                                    onChange={(e) => setFechaFinVivienda(e.value)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinVivienda}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div style={{ marginBottom: width < 1048 && width > 960 && '2rem' }}>
                                    <FormGroup>
                                        <Label htmlFor="label">Valor año {width > 425 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                        <InfoIcon msg={info[20]}
                                            element={
                                                <InputNumber
                                                    className="cont"
                                                    value={valorAnoPrepagada}
                                                    onChange={(e) => setValorAnoPrepagada(e.value)}
                                                    mode="currency" currency="COP" locale="es-CO"
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Valor mes {width > 425 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                        <InfoIcon msg={info[21]}
                                            element={
                                                <InputNumber
                                                    className="cont"
                                                    value={valorMesPrepagada}
                                                    onChange={(e) => setValorMesPrepagada(e.value)}
                                                    mode="currency" currency="COP" locale="es-CO"
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div style={{ marginTop: width > 960 && '1.5rem' }}>
                                    <FormGroup>
                                        <Label htmlFor="label">Inicio {width > 375 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                        <InfoIcon msg={info[22]}
                                            element={
                                                <Calendar id="navigators" value={fechaInicioPrepagada}
                                                    className="cont"
                                                    onChange={(e) => setFechaInicioPrepagada(e.value)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioPrepagada}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Fin {width > 375 && "certificado medicina"} prepagada{valorAnoPrepagada && "*"}</Label>
                                        <InfoIcon msg={info[23]}
                                            element={
                                                <Calendar id="navigators" value={fechaFinPrepagada}
                                                    className="cont"
                                                    onChange={(e) => setFechaFinPrepagada(e.value)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinPrepagada}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Dependiente{dependiente === "1" && "*"}</Label>
                                        <InfoIcon msg={info[24]}
                                            element={
                                                <div>
                                                    <Checkbox
                                                        inputId="binary"
                                                        checked={dependiente === "1"}
                                                        onChange={(e) => { handleClick(e.checked); console.log(dependiente) }}
                                                    />
                                                    <label htmlFor="binary" className='ml-1'>{dependiente ? "Si" : "No"}</label>
                                                </div>
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Inicio certificado dependiente{dependiente === "1" && "*"}</Label>
                                        <InfoIcon msg={info[25]}
                                            element={
                                                <Calendar id="navigators" value={fechaInicioDependiente}
                                                    className="cont"
                                                    onChange={(e) => setFechaInicioDependiente(e.value)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicioDependiente}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup style={{ marginTop: width < 321 && "2rem" }}>
                                        <Label htmlFor="label">Fin certificado dependiente{dependiente === "1" && "*"}</Label>
                                        <InfoIcon msg={info[26]}
                                            element={
                                                <Calendar id="navigators" value={fechaFinDependiente}
                                                    className="cont"
                                                    onChange={(e) => setFechaFinDependiente(e.value)}
                                                    locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinDependiente}
                                                    yearRange="1900:2060" />
                                            } />
                                    </FormGroup>
                                    <FormGroup style={{ display: width < 961 && 'none' }}>
                                        <Label htmlFor="label" style={{ display: 'none' }}>Fin certificado dependiente{dependiente === 1 && "*"}</Label>
                                        <Calendar id="navigators" value={fechaFinDependiente}
                                            style={{ display: 'none' }}
                                            disabled
                                            onChange={(e) => setFechaFinDependiente(e.value)}
                                            locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaFinDependiente}
                                            yearRange="1900:2060" />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <Card title="Otros datos contrato" style={cardStyle}>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">EPS*</Label>
                                        <InfoIcon msg={info[27]}
                                            element={
                                                <Dropdown value={eps}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay EPS disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setEps({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaEps} placeholder={eps.label}
                                                    tooltip={eps.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">AFP*</Label>
                                        <InfoIcon msg={info[28]}
                                            element={
                                                <Dropdown value={afp}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay AFP disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setAfp({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaAfp} placeholder={afp.label}
                                                    tooltip={afp.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Fondo cesantías*</Label>
                                        <InfoIcon msg={info[29]}
                                            element={
                                                <Dropdown value={fces}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay fondos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setFces({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaFces} placeholder={fces.label}
                                                    tooltip={fces.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Caja compensación*</Label>
                                        <InfoIcon msg={info[30]}
                                            element={
                                                <Dropdown value={ccf}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay CCF disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setCcf({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaCcf} placeholder={ccf.label}
                                                    tooltip={ccf.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">AFC{afc.value && '*'}</Label>
                                        <InfoIcon msg={info[31]}
                                            element={
                                                <Dropdown value={afc}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay AFC disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setAfc({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaAfc} placeholder={afc.label}
                                                    tooltip={afc.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Cuenta AFC{afc.value && '*'}</Label>
                                        <InfoIcon msg={info[32]}
                                            element={
                                                <InputText
                                                    className="cont"
                                                    id="label7"
                                                    type="text"
                                                    value={cuentaAfc}
                                                    onChange={(e) => setCuentaAfc(e.target.value)}
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Fondo voluntario</Label>
                                        <InfoIcon msg={info[33]}
                                            element={
                                                <Dropdown value={fvol}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay fondos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setFvol({ "value": e.value, "label": label })
                                                    }}
                                                    options={listaFvol} placeholder={fvol.label}
                                                    tooltip={fvol.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Nivel de riesgo ARL*</Label>
                                        <InfoIcon msg={info[34]}
                                            element={
                                                <Dropdown value={arl}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay opciones disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setArl({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaArl} placeholder={arl.label} />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div>
                                    <FormGroup>
                                        <Label htmlFor="label">Tipo cotizante*</Label>
                                        <InfoIcon msg={info[35]}
                                            element={
                                                <Dropdown value={tipoCotizante}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay tipos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setTipoCotizante({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaTipoCotizante} placeholder={tipoCotizante.label}
                                                    tooltip={tipoCotizante.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Subtipo cotizante*</Label>
                                        <InfoIcon msg={info[36]}
                                            element={
                                                <Dropdown value={subtipoCotizante}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay subtipos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setSubtipoCotizante({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaSubtipoCotizante} placeholder={subtipoCotizante.label}
                                                    tooltip={subtipoCotizante.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                                <Div >
                                    <FormGroup>
                                        <Label htmlFor="label">Actividad económica*</Label>
                                        <InfoIcon msg={info[38]}
                                            element={
                                                <Dropdown value={actividadEconomica}
                                                    className="cont"
                                                    filter showClear filterBy="label" emptyMessage={"No hay subtipos disponibles"}
                                                    onChange={(e) => {
                                                        let label = e.originalEvent.nativeEvent.target.textContent;
                                                        setActividadEconomica({ "value": e.value, "label": label })
                                                        ;
                                                    }}
                                                    options={listaActividadEconomica} placeholder={actividadEconomica.label}
                                                    tooltip={actividadEconomica.label}
                                                    tooltipOptions={{ position: 'top' }}
                                                />
                                            } />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label htmlFor="label">Foto empleado</Label>
                                        <InfoIcon msg={info[37]}
                                            element={
                                                <FileUpload
                                                    mode="basic" name="demo[]" ref={fileUploadRef} accept="image/*" maxFileSize={2000000} chooseLabel="Seleccionar"
                                                    onValidationFail={() => {
                                                        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
                                                    }} onClear={() => setFiles([])}
                                                    onSelect={(e) => setFiles(e.files)}
                                                />
                                            } />
                                    </FormGroup>
                                </Div>
                            </Card>
                            <div>
                                <Button type="submit" loading={loading1} label="Guardar" onClick={() => { setLoading1(true); handleGuardar() }} style={{ marginRight: "0.5rem" }} />
                                <Link style={{ textDecoration: 'none' }} to="/Employes">
                                    <Button block type="submit" label="Cancelar" style={{ marginLeft: "0.5rem" }} onclick={() => { setLoading1(false); }} />
                                </Link>
                            </div>
                        </Forms>
                    </div>
                </SkeletonTable>
            </Form>
        </div>
    );
}